// extracted by mini-css-extract-plugin
export var container = "_3n-0";
export var icon = "_3n-1";
export var text = "_3n-2";